module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-germany.27302329.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-germany.png
// module id = 2627
// module chunks = 11